import { RequestStatus } from '$views/UserArea/UserArea.model'
import * as dayjs from 'dayjs'
import { mapCaretakerQualification } from '../../nursingHome.mapper'
import { AccompanimentsHistoryService, AccompanimentsHistoryServiceDto } from './accompanimentsHistory.model'

export const mapAccompanimentsHistoryServiceList = (
  serviceListDto: AccompanimentsHistoryServiceDto[],
): AccompanimentsHistoryService[] => {
  return serviceListDto.map(serviceDto => ({
    serviceRef: serviceDto.serviceId,
    caretaker: {
      id: serviceDto.reservedRequest.caretakerId,
      userId: serviceDto.reservedRequest.caretakerUserId,
      requestId: serviceDto.reservedRequest.requestId,
      name: serviceDto.reservedRequest.caretakerName,
      image: serviceDto.reservedRequest.caretakerProfileImage,
      phone: serviceDto.reservedRequest.caretakerTelephone,
      email: serviceDto.reservedRequest.caretakerEmail,
      qualification: mapCaretakerQualification(serviceDto.reservedRequest.mainQualification),
      hourlyWage: serviceDto.reservedRequest.caretakerHourlyRate / 100,
      totalWage: serviceDto.reservedRequest.budget / 100,
      extras: serviceDto.reservedRequest.extraCharges.map(extra => ({
        concept: extra.concept,
        amount: extra.amount / 100,
      })),
      isRated: serviceDto.reservedRequest.isServiceRated,
    },
    caredPerson: serviceDto.resident,
    job: serviceDto.additionalInfo,
    dates: serviceDto.serviceSchedule.map(date => ({
      startTime: dayjs(date.start).toDate(),
      endTime: dayjs(date.end).toDate(),
    })),
    address: serviceDto.location,
    handler: serviceDto.requestedByInstitutionManager,
    isCancelled: serviceDto.reservedRequest.requestStatus === RequestStatus.requestAborted,
    confirmDurationLink: serviceDto.reservedRequest.residenceConfirmationLink,
    duration: serviceDto.estimatedDuration,
    caretakerDuration: serviceDto.caretakerProposedDuration,
    nursingHomeDuration: serviceDto.institutionProposedDuration,
  }))
}



// WEBPACK FOOTER //
// ./src/domain/model/nursingHome/accompaniments/accompanimentsHistory/accompanimentsHistory.mapper.ts